import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {apiClient} from 'common/util/api-client';
import {getProjectId} from 'common/report/util';
import {getLocation} from 'common/util/url';
import {ProjectMember} from 'common/types/app-api/project-member';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint() {
  return appApiUrl(`granted-users`, {projectId: getProjectId()});
}

async function fetchProjectUsers(fromFetchCache: boolean): Promise<{[key: string]: ProjectMember}> {
  // eslint-disable-next-line local-rules/deprecated-member-access
  const result = await apiClient.fetch(buildEndpoint(), {
    headers: {
      'Request-URL': getLocation().href,
    },
    method: `GET`,
    fromFetchCache,
  });
  const projectUsers: ProjectMember[] = (await result?.json())?.results?.members ?? [];
  // If this is from cache, and it's empty, return null instead of an empty set.
  // Otherwise, ApiResource will signal that the index fetch is done, when it really isn't
  if (!projectUsers.length && fromFetchCache) {
    return null as any;
  }
  const initialValue: {[key: string]: ProjectMember} = {};
  return projectUsers.reduce((acc, userItem) => {
    acc[userItem.id.toString()] = userItem;
    return acc;
  }, initialValue);
}

export const projectUsersClient: ApiResourceClient<ProjectMember> = {
  index() {
    return {
      cache: fetchProjectUsers(true),
      network: fetchProjectUsers(false),
    };
  },

  get() {
    throw new Error(`Getting a single project user is not supported`);
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
